export const ProjectActiveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4998 9.3C17.8864 9.3 18.1998 9.6134 18.1998 10L18.1998 16.5C18.1998 16.8866 17.8864 17.2 17.4998 17.2C17.1132 17.2 16.7998 16.8866 16.7998 16.5L16.7998 10C16.7998 9.6134 17.1132 9.3 17.4998 9.3Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4998 9.3C6.8864 9.3 7.19981 9.6134 7.1998 10L7.1998 16.5C7.1998 16.8866 6.8864 17.2 6.49981 17.2C6.11321 17.2 5.79981 16.8866 5.79981 16.5L5.7998 10C5.7998 9.6134 6.11321 9.3 6.4998 9.3Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4 13.3H5.8V16.5C5.8 16.8866 5.4866 17.2 5.1 17.2C4.7134 17.2 4.4 16.8866 4.4 16.5V13.6391L0.403644 20.1332C0.270734 20.3492 0.265032 20.6201 0.388737 20.8415C0.512443 21.0629 0.746207 21.2 0.999805 21.2H22.9998C23.2534 21.2 23.4872 21.0629 23.6109 20.8415C23.7346 20.6201 23.7289 20.3492 23.596 20.1332L19.596 13.6332C19.4686 13.4262 19.2429 13.3 18.9998 13.3H16.8V16.5C16.8 16.8866 16.4866 17.2 16.1 17.2C15.7134 17.2 15.4 16.8866 15.4 16.5V13.3Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4883 3.30005C22.871 3.29572 23.1862 3.59953 23.196 3.98212C23.2097 4.51909 23.1936 5.36465 23.0249 6.25997C22.8579 7.14635 22.5297 8.1455 21.8733 8.93356C20.5665 10.5061 18.4131 10.6897 17.5077 10.7C17.3207 10.7021 17.1406 10.6293 17.0076 10.4978C16.8746 10.3663 16.7998 10.187 16.7998 10V9.43636L16.8 9.41832C16.8293 8.28172 17.0345 6.3675 18.12 5.06626C19.4269 3.49374 21.5833 3.31029 22.4883 3.30005Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4883 3.30005C11.871 3.29572 12.1862 3.59953 12.196 3.98212C12.2097 4.51909 12.1936 5.36465 12.0249 6.25997C11.8579 7.14635 11.5297 8.1455 10.8733 8.93356C9.5665 10.5061 7.41314 10.6897 6.50773 10.7C6.32072 10.7021 6.14063 10.6293 6.00764 10.4978C5.87465 10.3663 5.7998 10.187 5.7998 10V9.43636L5.80004 9.41832C5.82933 8.28172 6.03447 6.3675 7.12 5.06626C8.42694 3.49374 10.5833 3.31029 11.4883 3.30005Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7999 8.01111C11.7953 7.62802 12.0996 7.31246 12.4826 7.30307C12.9337 7.29201 13.6451 7.30491 14.3997 7.4414C15.1445 7.57612 15.9968 7.84261 16.6749 8.38473C18.0367 9.47123 18.1911 11.2569 18.1998 11.9917C18.202 12.1788 18.1292 12.359 17.9977 12.492C17.8662 12.6251 17.6869 12.7 17.4998 12.7L17.0301 12.7L17.0128 12.6998C16.066 12.6764 14.4401 12.5136 13.3245 11.6203C11.9627 10.5336 11.8085 8.74554 11.7999 8.01111Z"
        fill="#2ED0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.799854 8.01111C0.795336 7.62802 1.09963 7.31246 1.48264 7.30307C1.93367 7.29201 2.6451 7.30491 3.39969 7.4414C4.1445 7.57612 4.99683 7.84261 5.67486 8.38473C7.03674 9.47123 7.19109 11.2569 7.19976 11.9917C7.20196 12.1788 7.1292 12.359 6.99769 12.492C6.86619 12.6251 6.68689 12.7 6.49981 12.7L6.0301 12.7L6.01279 12.6998C5.06595 12.6764 3.44008 12.5136 2.32454 11.6203C0.962696 10.5336 0.808515 8.74554 0.799854 8.01111Z"
        fill="#2ED0FF"
      />
    </svg>
  );
};
